import { useMemo } from 'react';
import styled from 'foundations-theming/utils';
// @ts-expect-error untyped external dependency
import MarkdownIt from 'markdown-it';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config as sanitizerConfig } from 'sanitize-text/sanitizers/SanitizeConfiguration';

// `html: false` escapes any raw HTML in the source so only markdown-it's own
// (allowlisted) output is produced; sanitize-text then strips anything outside
// the HTML allowlist as defence in depth. `typographer` is left off so author
// content like CLI flags (`--force`) and quoted code values are not mutated.
import { jsx as _jsx } from "react/jsx-runtime";
const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
  typographer: false
});
const MarkdownContainer = styled.div.withConfig({
  displayName: "MarkdownText__MarkdownContainer"
})(({
  theme
}) => ({
  'ul, ol': {
    margin: `${theme.space['200']} 0`,
    paddingInlineStart: theme.space['700']
  },
  ul: {
    listStyle: 'disc'
  },
  ol: {
    listStyle: 'decimal'
  },
  li: {
    marginBlockEnd: theme.space['100']
  },
  'strong, b': {
    fontWeight: 'bold'
  },
  'p:not(:last-child)': {
    marginBlockEnd: theme.space['200']
  }
}));
export const MarkdownText = ({
  text
}) => {
  const safeHtml = useMemo(() => sanitize(md.render(text), sanitizerConfig.HTML), [text]);
  return /*#__PURE__*/_jsx(MarkdownContainer
  // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml -- markdown is rendered with html disabled and sanitized against the sanitize-text HTML allowlist (config.HTML) before rendering
  , {
    dangerouslySetInnerHTML: {
      __html: safeHtml
    }
  });
};
export default MarkdownText;